function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "17",
  height: "16",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.73 1.888L14.273.43a1.446 1.446 0 00-2.042 0l-1.395 1.395 3.266 3.267 1.628-1.628a1.114 1.114 0 000-1.577zm-5.745.788l3.267 3.266-8.269 8.268-3.264-3.266 8.266-8.268zM.459 15.977a.372.372 0 01-.45-.442l.825-3.707L4.1 15.095l-3.64.882z"
})));